// This file is auto-generated during build
export const PACKAGE_VERSION = "0.4.3";
